// extracted by mini-css-extract-plugin
export default {"scoreContainer":"FormulaScoreComponent_scoreContainer__uqnLz","header":"FormulaScoreComponent_header__6B1Oz","options":"FormulaScoreComponent_options__wDsUa"};